<template>
  <AuthPopup
    :model-value="store.isOpen"
    :persistent="store.persistent"
    @update:model-value="store.handleModelUpdate"
    @success="store.handleSuccess"
  />
</template>

<script setup lang="ts">
import { AuthPopup } from '~/features/auth'
import { useAuthPopupStore } from '../model/useAuthPopupStore'

const store = useAuthPopupStore()
</script>
